// NOVAPAY-116-R5 + R2-R8-R1 — exit-rescue copy aligned with honest share (no %).
import type { StoreV2Lang } from "./store-v2-locale.js";
import { StoreV2Icon } from "./StoreV2Icon.js";
import { paidShareBody, paidShareCta, paidShareTitle } from "./referral-share-v2.js";

export function ReferralExitRescueSheetV2({
  lang,
  open,
  onShare,
  onDismiss,
}: {
  lang: StoreV2Lang;
  open: boolean;
  onShare: () => void;
  onDismiss: () => void;
}) {
  if (!open) return null;
  return (
    <div className="sv2-exit-rescue" data-testid="sv2-referral-exit-rescue" role="dialog" aria-modal="true">
      <button type="button" className="sv2-exit-rescue-backdrop" aria-label="Close" onClick={onDismiss} />
      <div className="sv2-exit-rescue-sheet">
        <div className="sv2-exit-rescue-icon" aria-hidden="true">
          <StoreV2Icon name="gift" size={28} />
        </div>
        <h3 data-testid="sv2-exit-rescue-title">{paidShareTitle(lang)}</h3>
        <p className="sv2-muted" data-testid="sv2-exit-rescue-body">
          {paidShareBody(lang)}
        </p>
        <button type="button" className="sv2-cta" data-testid="sv2-exit-rescue-share" onClick={onShare}>
          {paidShareCta(lang)}
        </button>
        <button
          type="button"
          className="sv2-cta sv2-secondary"
          data-testid="sv2-exit-rescue-dismiss"
          onClick={onDismiss}
        >
          {lang === "en" ? "Not now" : "Не зараз"}
        </button>
      </div>
    </div>
  );
}
